import { IMAGE_LOADER } from '@angular/common';
import {
  ErrorHandler,
  ApplicationConfig,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { NbDatepickerModule, NbDialogModule, NbMenuModule, NbTimepickerModule } from '@nebular/theme';
import { SntApiService, SntServerErrorsModule, trimInterceptor } from '@senet-uiverse/common';
import { SntWebsocketsModule } from '@senet-uiverse/websockets';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ThemeModule, provideToast, avatarsLoader } from 'ui';
import { provideQueryClientOptions } from '@ngneat/query';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { SntI18nModule } from '@senet-uiverse/i18n';
import { AbilityModule } from '@casl/angular';

import { urlInterceptor, authInterceptor, errorInterceptor, languageInterceptor } from './core/interceptors';
import { ErrorService } from './core/services';
import { appRoutes } from './app.routes';
import BASE from './app.base';

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([urlInterceptor, languageInterceptor, authInterceptor, errorInterceptor, trimInterceptor]),
    ),
    importProvidersFrom(
      ThemeModule,
      AbilityModule,
      NbTimepickerModule.forRoot(),
      NbMenuModule.forRoot(),
      NbDatepickerModule.forRoot(),
      NbDateFnsDateModule,
      provideToast(BASE.toastConfig),
      SntI18nModule.forRoot(BASE.i18nConfig),
      NbDialogModule.forRoot(BASE.nbDialogConfig),
      SntServerErrorsModule.forRoot(BASE.errorConfig),
      NgxSkeletonLoaderModule.forRoot(BASE.skeletonSettings),
      SntWebsocketsModule.forRoot({ tokenService: SntApiService, options: { debug: false } }),
    ),
    provideQueryClientOptions(BASE.queryConfig),
    { provide: ErrorHandler, useClass: ErrorService },
    { provide: IMAGE_LOADER, useValue: avatarsLoader },
  ],
};
